import { FriendApiFriendCreateRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useFriendCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: FriendApiFriendCreateRequest, config) =>
      appApiClient.friendApi.friendCreate(req, config),
  })
